
'use strict';

import Chart from 'chart.js';

const config = {
    chartContainer: '.c-chart-canvas-container',
    chartData: 'chart-data',
    chartLabelColour: 'label-colour',
    chartLabelsData: 'labels',
    chartLegendTarget: '.js-lifetime-risk-legend',
    chartTarget: '#lifetimeRisk',
    chartTitle: 'chart-title',
    spinnerClass: 'is-loading'
};

class lifetimeRiskSummary {

    constructor() {
        if(!$(config.chartTarget).length) {
            return;
        }

        this.setupChart();
    }

    setupChart() {
        let chart = $(config.chartTarget);
        let chartContainer = $(config.chartTarget).parents(config.chartContainer);
        let chartTitle = $(config.chartTarget).data(config.chartTitle);
        let data = $(config.chartTarget).data(config.chartData);
        let labels = $(config.chartTarget).data(config.chartLabelsData);
        let labelColours = $(config.chartTarget).data(config.chartLabelColour);

        const windowSizeBreakpoint = 1130;

        if (!chartContainer.hasClass(config.spinnerClass)) {
            chartContainer.addClass(config.spinnerClass);
        }

        let lifetimeRisk = new Chart(chart, {
            type: 'pie',
            data: {
                labels: labels,
                datasets: [{
                    data: data,
                    backgroundColor: labelColours
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: 'left',
                    fullWidth: false,
                    labels: {
                        fontColor: '#000000',
                        fontSize: 9,
                        boxWidth: 10
                    }
                },
                title: {
                    display: true,
                    text: chartTitle,
                    fullWidth: false,
                    fontColor: '#000000',
                    fontSize: 16
                },
                animation: {
                    onProgress: function() {
                        chartContainer.removeClass(config.spinnerClass)
                    }
                }
            }
        });

        chart.attr('style', "height: 300px;");

        this.resizeLegendLabels(lifetimeRisk, windowSizeBreakpoint);

        $(window).resize(() => {
            this.resizeLegendLabels(lifetimeRisk, windowSizeBreakpoint);
        });
    }

    resizeLegendLabels(chart, breakpoint) {
        if ($(window).width() > breakpoint) {
            chart.options.legend.labels.fontSize = 14;
            chart.options.legend.labels.boxWidth = 40;
        } else if ($(window).width() < breakpoint) {
            chart.options.legend.labels.fontSize = 9;
            chart.options.legend.labels.boxWidth = 10;
        }

        chart.update();
    }
}

$(window).load(function(){
    new lifetimeRiskSummary();
});



// WEBPACK FOOTER //
// ./src/js/components/lifetime-risk-summary.js